'use strict';

export { default as CSSManager } from "./CSSManager.js";
//# sourceMappingURL=index.js.map